import React, { useEffect } from 'react'
import { BrowserRouter as Router } from 'react-router-dom'
import { I18nextProvider } from 'react-i18next'
import { InstitutionalProvider } from './contexts/InstitutionalContext'
import { LanguageProvider } from './contexts/LanguageContext'
import InstitutionalLayout from './layouts/InstitutionalLayout'
import ErrorBoundary from './components/ErrorBoundary'
import { initPerformanceMonitoring } from './utils/performance'
import { initGA4 as initAnalytics } from './utils/analytics'
import i18n from './utils/i18n'

import ScrollToTop from './components/common/ScrollToTop'
import LocalizedRoutes from './components/LocalizedRoutes'

// Loading component for Suspense
const PageLoader = () => (
  <div className="min-h-screen flex items-center justify-center">
    <div className="text-center">
      <div className="w-8 h-8 border-4 border-primary-600 border-t-transparent rounded-full animate-spin mx-auto mb-4"></div>
      <p className="text-secondary-600">Carregando...</p>
    </div>
  </div>
)

// Loading para o i18n
const I18nLoader = ({ children }) => {
  const [isReady, setIsReady] = React.useState(false)

  React.useEffect(() => {
    // Aguardar i18n estar pronto
    if (i18n.isInitialized) {
      setIsReady(true)
    } else {
      i18n.on('initialized', () => {
        setIsReady(true)
      })
    }
  }, [])

  if (!isReady) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="text-center">
          <div className="w-8 h-8 border-4 border-primary-600 border-t-transparent rounded-full animate-spin mx-auto mb-4"></div>
          <p className="text-secondary-600">Carregando idioma...</p>
        </div>
      </div>
    )
  }

  return children
}

function App() {
  useEffect(() => {
    // Inicializar monitoramento de performance
    initPerformanceMonitoring()

    // Inicializar analytics
    initAnalytics()

    // Dispatch event for prerender plugin to know when React finished rendering
    // This is used by vite-plugin-prerender during build time
    document.dispatchEvent(new Event('render-complete'))
  }, [])

  return (
    <ErrorBoundary>
      <I18nextProvider i18n={i18n}>
        <I18nLoader>
          <LanguageProvider>
            <InstitutionalProvider>
              <Router>
                <ScrollToTop />
                <React.Suspense fallback={<PageLoader />}>
                  <LocalizedRoutes layout={InstitutionalLayout} />
                </React.Suspense>
              </Router>
            </InstitutionalProvider>
          </LanguageProvider>
        </I18nLoader>
      </I18nextProvider>
    </ErrorBoundary>
  )
}

export default App
